import axios from './axios'

export const saveProject = async project => {
        try {
                const response = await axios.post(`/save`, project, {
                        headers: {
                                'Content-Type': 'application/json',
                        },
                })
                return response.data
        } catch (error) {
                console.error('API Error:', error)
                throw error
        }
}

export const fetchProjects = async () => {
        try {
                const response = await axios.get('/save/list')
                return response.data
        } catch (error) {
                console.error('API Error:', error)
                throw error
        }
}

// export const fetchProjectById = async projectId => {
//      try {
//              const response = await axios.get(`/api/projects/${projectId}`)
//              return response.data
//      } catch (error) {
//              console.error('Error fetching project:', error)
//              throw error
//      }
// }

export const deleteProjectById = async projectId => {
        try {
                const response = await axios.delete(`/save/delete/${projectId}`)
                return response.data
        } catch (error) {
                console.error('API Error deleting project:', error)
                throw error
        }
}

export const fetchProjectById = async id => {
        try {
                const response = await axios.get(`/save/one`, {
                        params: { id },
                })
                return response.data
        } catch (error) {
                console.error('API Error fetching project by id:', error)
                throw error
        }
}

export const saveProjectFromData = async (projectId, data) => {
        try {
                const response = await axios.post(
                        '/save',
                        {
                                id: projectId,
                                ...data,
                        },
                        {
                                headers: {
                                        'Content-Type': 'application/json',
                                },
                        }
                )
                return response.data
        } catch (error) {
                console.error('Ошибка при сохранении проекта:', error)
                throw error
        }
}

export const updateProjectCover = async (projectId, coverImage, onUploadProgress = null) => {
        try {
                const config = {
                        headers: {
                                'Content-Type': 'application/json',
                        },
                        maxContentLength: 10 * 1024 * 1024,
                        maxBodyLength: 10 * 1024 * 1024,
                        timeout: 120000,
                }
                if (onUploadProgress) {
                        config.onUploadProgress = onUploadProgress
                }
                const response = await axios.put(`/save/cover/${projectId}`, {
                        coverImage
                }, config)
                return response.data
        } catch (error) {
                console.error('Ошибка обновления обложки:', error.response?.data || error.message || error)
                throw error
        }
}
